"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const button_1 = __importDefault(require("components/cosmos/button/button"));
const constants_1 = require("components/cosmos/toast/constants");
const modal_1 = require("components/cosmos/v2/modal");
const Html_1 = __importDefault(require("components/Html"));
const translationContext_1 = require("configs/translationContext");
const clubWebSocket_1 = require("helpers/clubWebSocket");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const dripping_1 = require("modules/app/services/datahub/dripping");
const useDatahubBaseEvent_1 = __importDefault(require("modules/app/services/datahub/useDatahubBaseEvent"));
const ModuleEditorParamsUtils_1 = __importDefault(require("modules/content/moduleEditor/ModuleEditorParamsUtils"));
const ui_1 = require("modules/ui");
const bulkDrippingCounter_1 = __importDefault(require("./bulkDrippingCounter"));
const bulkDrippingFeedback_1 = __importDefault(require("./bulkDrippingFeedback"));
const useBulkRequest_1 = __importDefault(require("../hooks/useBulkRequest"));
const useBulkWizardActionsContext_1 = __importDefault(require("../hooks/useBulkWizardActionsContext"));
const drippingService_1 = __importDefault(require("../services/drippingService"));
const stores_1 = require("../stores");
const bulkDeleteDrippingStepper_module_scss_1 = __importDefault(require("./bulkDeleteDrippingStepper.module.scss"));
const mapStateToProps = (stores) => ({
    isMobile: stores.UiStore.isMobile
});
var BulkDeleteDrippingSteps;
(function (BulkDeleteDrippingSteps) {
    BulkDeleteDrippingSteps[BulkDeleteDrippingSteps["Confirm"] = 1] = "Confirm";
    BulkDeleteDrippingSteps[BulkDeleteDrippingSteps["Processing"] = 2] = "Processing";
})(BulkDeleteDrippingSteps || (BulkDeleteDrippingSteps = {}));
const BulkDeleteDrippingStepper = ({ isMobile }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const [currentStep, setCurrentStep] = (0, react_1.useState)(BulkDeleteDrippingSteps.Confirm);
    const { modules, pages, onProcessFinish } = (0, useBulkWizardActionsContext_1.default)();
    const [callbackContextId] = (0, react_1.useState)(clubWebSocket_1.ClubWebSocketUtil.generateContextId());
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { captureException } = (0, useBulkRequest_1.default)();
    const baseEvent = (0, useDatahubBaseEvent_1.default)();
    const handleCloseModal = () => {
        stores_1.BulkDrippingStore.resetAction();
        dripping_1.DatahubBulkDrippingService.sendCancelRemoveBulk({
            ...baseEvent,
            numberOfModulesSelected: modules.length,
            numberOfPagesSelected: pages.length,
            isExtraModule: ModuleEditorParamsUtils_1.default.getExtraParam()
        });
    };
    const handleConfirm = async () => {
        setIsLoading(true);
        const onSuccess = async () => {
            await drippingService_1.default.removeDrippingBulk({
                callbackContextId,
                modules,
                pages
            });
            setCurrentStep(BulkDeleteDrippingSteps.Processing);
            dripping_1.DatahubBulkDrippingService.sendRemoveBulkEvent({
                ...baseEvent,
                bulkId: callbackContextId,
                numberOfModulesSelected: modules.length,
                numberOfPagesSelected: pages.length,
                isExtraModule: ModuleEditorParamsUtils_1.default.getExtraParam()
            });
        };
        await captureException({ onSuccess });
    };
    const handleFinish = () => {
        onProcessFinish === null || onProcessFinish === void 0 ? void 0 : onProcessFinish();
        stores_1.BulkDrippingStore.resetAction();
        stores_1.BulkDrippingStore.setActionInProgress(false);
    };
    const sendRemoveBulkProcess = ({ total, completed }) => {
        dripping_1.DatahubBulkDrippingService.sendRemoveBulkProcess({
            ...baseEvent,
            parentBulkId: callbackContextId,
            numberOfItems: total,
            numberOfItemsProcessed: completed,
            processingTimeInSeconds: stores_1.BulkDrippingStore.getBulkProcessTimeInSeconds()
        });
    };
    const handleDone = (statusMessage) => {
        sendRemoveBulkProcess(statusMessage);
        handleFinish();
        ui_1.UiService.setAlertWithText({
            message: t('dripping_2.notifications.delete_success'),
            type: constants_1.TOAST_TYPE.success
        });
    };
    const handlePartiallyDone = (statusMessage) => {
        sendRemoveBulkProcess(statusMessage);
        handleFinish();
        ui_1.UiService.setAlertWithText({
            message: t('dripping_2.notifications.create_error'),
            type: constants_1.TOAST_TYPE.danger
        });
    };
    const renderComponentByStep = () => {
        const STEP_COMPONENTS = {
            [BulkDeleteDrippingSteps.Confirm]: ((0, jsx_runtime_1.jsxs)(modal_1.Modal, { show: true, className: bulkDeleteDrippingStepper_module_scss_1.default.container, onClose: handleCloseModal, children: [(0, jsx_runtime_1.jsxs)(modal_1.Modal.Header, { className: "_p-5", children: [(0, jsx_runtime_1.jsx)("h3", { className: "_text-3 _text-lg-4 _text-gray-700 _font-weight-light _mt-0 _mb-2", children: t('dripping_2.bulk_action.remove.title') }), (0, jsx_runtime_1.jsx)(bulkDrippingCounter_1.default, {})] }), (0, jsx_runtime_1.jsx)(modal_1.Modal.Body, { className: "_py-0 _px-5", children: (0, jsx_runtime_1.jsx)(Html_1.default, { tag: "p", className: "_text-gray-700", children: t('dripping_2.bulk_action.remove.description') }) }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Footer, { className: "_flex-column-reverse _flex-lg-row _justify-content-lg-end _p-5", children: [(0, jsx_runtime_1.jsx)(button_1.default, { variation: "default", className: "_mt-4 _mt-lg-0 _mr-lg-3", onClick: handleCloseModal, size: isMobile ? 'block' : 'md', children: t('general.cancel') }), (0, jsx_runtime_1.jsxs)(button_1.default, { variation: "danger", loading: isLoading, disabled: isLoading, onClick: handleConfirm, size: isMobile ? 'block' : 'md', children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'trash'], className: "_mr-3" }), t('general.exclude')] })] })] })),
            [BulkDeleteDrippingSteps.Processing]: ((0, jsx_runtime_1.jsx)(bulkDrippingFeedback_1.default, { title: t('dripping_2.bulk_action.report.delete_title'), contextId: callbackContextId, onDone: handleDone, onPartiallyDone: handlePartiallyDone, onError: handleFinish }))
        };
        return STEP_COMPONENTS[currentStep];
    };
    return renderComponentByStep();
};
exports.default = (0, flowRight_1.default)((0, mobx_react_1.inject)(mapStateToProps))(BulkDeleteDrippingStepper);
